import React, { ReactElement, useEffect, useState } from "react";

import classnames from "classnames";
import TableCell from "../../data-table/components/table-cell";
// icons
import { DownArrowIcon, UpArrowIcon } from "~/core/icons";
import { IColumnData, ISortOptions, IRecord, IIndex } from "../../interfaces";

const DESC = "DESC";
const ASC = "ASC";

interface IHeaderCellProps {
    columnName: IColumnData | IColumnData[];
    sortOptions?: ISortOptions;
    classNames?: string;
    onSortOption?: (columnName: IColumnData) => void;
}

const HeaderCell = ({
    columnName,
    sortOptions,
    classNames = "",
    onSortOption,
}: IHeaderCellProps): ReactElement => {
    const { sortColumnName, sortDirection } = sortOptions;
    const className = classnames("data-header-cell", classNames);
    function renderSortIcon(columnName: IColumnData): ReactElement {
        if (sortDirection && sortColumnName.toUpperCase() === columnName.dataKey.toUpperCase()) {
            if (sortDirection === DESC) {
                return <DownArrowIcon className="data-header-sorting-icon" />;
            } else {
                return <UpArrowIcon className="data-header-sorting-icon" />;
            }
        }
        return <p />;
    }

    return (
        <div
            className={classnames(className)}
            onClick={() => onSortOption(columnName as IColumnData)}
        >
            <TableCell title={(columnName as IColumnData).title}>
                {(columnName as IColumnData).title}
            </TableCell>
            <a className="plain-data-table-sort-icon " href="#/">
                {renderSortIcon(columnName as IColumnData)}
            </a>
        </div>
    );
};

interface IPlainTableHeaderProps {
    sortRecords?: (sort: ISortOptions) => void;
    columns: Record<string, Partial<IColumnData>>;
    classNames?: string;
    onDelete?: (record: IRecord, index: IIndex) => void;
    onEdit?: (record: IRecord, index: IIndex) => void;
}

export default function PlainTableHeader(props: IPlainTableHeaderProps) {
    const [sortOptions, setSortOptions] = useState<ISortOptions>({});
    const { columns, classNames, onDelete, onEdit, sortRecords } = props;
    const columnKeys = Object.keys(columns);
    const className = classnames("data-table-row", "data-table-header", classNames);

    function onSortOption(value): void {
        setSortOptions({
            sortColumnName: value.dataKey,
            sortDirection:
                sortOptions.sortColumnName === value.dataKey && sortOptions.sortDirection === ASC
                    ? DESC
                    : ASC,
        });
    }

    useEffect(() => {
        const { sortColumnName } = sortOptions;
        sortRecords({ sortOptions, sortColumnName });
    }, [sortOptions, sortRecords]);

    return (
        <div className={className}>
            {!onDelete ? null : <TableCell className={"z-n-icon"}></TableCell>}
            {!onEdit ? null : <TableCell className={"z-n-icon"}></TableCell>}
            {columnKeys.map((columnName) => (
                <HeaderCell
                    key={`header-cell-${columnName}`}
                    sortOptions={sortOptions}
                    onSortOption={onSortOption}
                    columnName={{ dataKey: columnName, ...columns[columnName] } as IColumnData}
                    classNames={columns[columnName].className}
                />
            ))}
        </div>
    );
}
